import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Layout } from '../Layout/Layout.js';
import { CardContainer } from './CardContainer.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["areas", "columns", "gap", "items", "rows"];
var CardBase = /*#__PURE__*/React.forwardRef(function Card(props, ref) {
  var areas = props.areas,
    columns = props.columns,
    gap = props.gap,
    items = props.items,
    rows = props.rows,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/jsx(CardContainer, _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref,
    children: /*#__PURE__*/jsx(Layout, {
      areas: areas,
      columns: columns,
      items: items,
      gap: gap,
      rows: rows,
      style: {
        height: "100%",
        width: "100%"
      }
    })
  }));
});
CardBase.displayName = "CardBase";

export { CardBase };
